"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Actionable_1 = require("@oui/core/Actionable");
var InternalInput = function (props, ref) {
    var onChange = props.onChange, rest = __rest(props, ["onChange"]);
    var handleChange = React.useCallback(function (event) {
        var attributes = event.target.attributes;
        var ariaDisabled = attributes && attributes.getNamedItem("aria-disabled");
        var disabled = rest.disabled || (ariaDisabled && ariaDisabled.value === "true");
        var readOnlyAttr = attributes && attributes.getNamedItem("readonly");
        var readOnly = rest.readOnly || (readOnlyAttr && readOnlyAttr.value === "true");
        if (disabled || readOnly) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        onChange && onChange(event);
    }, [onChange, rest.disabled, rest.readOnly]);
    var actionableProps = __assign({}, rest, { ref: ref, onChange: handleChange });
    return React.createElement(Actionable_1.default, __assign({}, actionableProps));
};
var ForwardedInternalInput = React.forwardRef(InternalInput);
ForwardedInternalInput.displayName = "forwarded(InternalInput)";
exports.default = ForwardedInternalInput;
//# sourceMappingURL=InternalInput.js.map